import React from 'react';
import { Button } from '@mui/material';

const ImportModal = ({ onClose, onFileSelect }) => {
  return (
    <div className="upload-overlay">
      <div className="upload-modal">
        <div className="upload-header">
          <span style={{ color: 'white' }}></span>
          <span>Browse files to upload</span>
          {/* <X size={18} className="upload-close" onClick={onClose} /> */}
          <img
            src={process.env.PUBLIC_URL + '/assests/img/close.svg'}
            alt=""
            onClick={onClose}
            style={{ height: '20px', width: '15px', cursor: 'pointer' }}
          />
        </div>
        <div className="upload-body">
          <div className="upload-icon">
            <img
              src={process.env.PUBLIC_URL + '/assests/img/uploadBgIcon.svg'}
              alt=""
            />
          </div>
          <Button
            variant="contained"
            component="label"
            className="appuploadresume"
          >
            <span>
              <b style={{ color: 'var(--primary-bg-color)' }}>Upload</b>
              <b style={{ color: '#9E9E9E' }}> browse file to upload </b>
            </span>
            <input
              hidden
              type="file"
              id="fileId"
              multiple
              onChange={(e) => onFileSelect(e.target.files[0])}
            />
          </Button>
          <p className="upload-note">Supported file formats: JSON</p>
        </div>
      </div>
    </div>
  );
};

export default ImportModal;
